import { Link } from "gatsby"
import React from "react"
import Transition from "../pages/transition"

const CaseStudyLandingSection = ({ title, subtitle, websiteUrl = "" }) => (
  <>
    <section className="landing-head-section">
      <div className="container ">
        <div className="row align-items-center banner-section">
          <div className="col-md-12 mt-auto">
            <Transition
              data={
                <>
                  <h1 className="text-white text-center">{title}</h1>
                  <p className="text-white text-center">{subtitle}</p>
                </>
              }
            ></Transition>
          </div>

          <div className="col-md-12 mt-auto pb-4">
            {websiteUrl != "" && (
              <Transition
                data={
                  <>
                    <p className="text-white text-center">
                      <Link
                        to={websiteUrl}
                        className="text-white"
                        target="_blank"
                      >
                        Visit Website
                      </Link>
                    </p>
                  </>
                }
              ></Transition>
            )}
          </div>
        </div>
      </div>
    </section>
  </>
)

export default CaseStudyLandingSection
